var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconComments = function SvgIconComments(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#979AAF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.536 4.857H4.655c-.344 0-.607.176-.607.405 0 .23.263.405.607.405h6.88c.345 0 .608-.176.608-.405 0-.23-.263-.405-.607-.405zM11.536 7.286H4.655c-.344 0-.607.175-.607.404 0 .23.263.405.607.405h6.88c.345 0 .608-.175.608-.405 0-.229-.263-.404-.607-.404zM11.536 8.905H4.655c-.344 0-.607.175-.607.405 0 .229.263.404.607.404h6.88c.345 0 .608-.175.608-.404 0-.23-.263-.405-.607-.405z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.669 0H7.331C3.289 0 0 3.278 0 7.305v8.096c0 .474.258.671.416.73.1.04.178.06.277.06.337 0 .615-.257.952-.573.435-.395 1.11-1.007 1.723-1.007H9.67c4.042 0 7.331-3.278 7.331-7.306C17 3.278 13.711 0 9.669 0zm0 13.426h-6.3c-.872 0-1.625.533-2.18 1.027V7.305c0-3.376 2.754-6.12 6.142-6.12h2.338c3.388 0 6.142 2.744 6.142 6.12 0 3.377-2.754 6.121-6.142 6.121z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconComments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-comments.27fb3ba7.svg";
export { ForwardRef as ReactComponent };